import { ToolItem } from '../types';
import { PDF_TOOLS_DATA } from './pdfToolsData';
import { IMAGE_TOOLS_DATA } from './imageToolsData';
import { TEXT_TOOLS_DATA } from './textToolsData';
import { DEV_TOOLS_DATA } from './devToolsData';
import { COLOR_TOOLS_DATA } from './colorToolsData';
import { SECURITY_TOOLS_DATA } from './securityToolsData';
import { SOCIAL_TOOLS_DATA } from './socialToolsData';
import { CALCULATOR_TOOLS_DATA } from './calculatorToolsData';
import { FILE_TOOLS_DATA } from './fileToolsData';
import { DATA_TOOLS_DATA } from './dataToolsData';
import { PRODUCTIVITY_TOOLS_DATA } from './productivityToolsData';
import { UNIT_CONVERSION_TOOLS_DATA } from './unitConversionToolsData';
import { TIME_DATE_TOOLS_DATA } from './timeDateToolsData';
import { FINANCE_TOOLS_DATA } from './financeToolsData';
import { MISC_TOOLS_DATA } from './miscToolsData';

export interface ExtendedToolItem extends ToolItem {
  categoryTitle: string;
  categoryId: string;
  iconName?: string;
  badge?: string;
  isPopular?: boolean;
  isNew?: boolean;
}

export const ALL_TOOLS_DATA: ExtendedToolItem[] = [
  ...PDF_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'PDF Tools', categoryId: 'pdf-tools' })),
  ...IMAGE_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Image Tools', categoryId: 'image-tools' })),
  ...TEXT_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Text Tools', categoryId: 'text-tools' })),
  ...DEV_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Developer Tools', categoryId: 'developer-tools' })),
  ...COLOR_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Color Tools', categoryId: 'color-tools' })),
  ...SECURITY_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Security Tools', categoryId: 'security-tools' })),
  ...SOCIAL_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Social Media Tools', categoryId: 'social-tools' })),
  ...CALCULATOR_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Calculators', categoryId: 'calculator-tools' })),
  ...FILE_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'File Tools', categoryId: 'file-tools' })),
  ...DATA_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Data & Converters', categoryId: 'data-tools' })),
  ...PRODUCTIVITY_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Productivity Utilities', categoryId: 'productivity-tools' })),
  ...UNIT_CONVERSION_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Unit Conversion', categoryId: 'unit-conversion' })),
  ...TIME_DATE_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Time & Date Tools', categoryId: 'time-date-tools' })),
  ...FINANCE_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Financial Calculators', categoryId: 'finance-tools' })),
  ...MISC_TOOLS_DATA.map((t) => ({ ...t, categoryTitle: 'Miscellaneous Tools', categoryId: 'misc-tools' }))
];
